module.exports = __webpack_public_path__ + "assets/ewm-wj.7e7969e2.jpg";